import styles from "./ButtonSlideProducts.module.css";

const ButtonSlide = ({
  title,
  onClick,
  isActive,
  value,
  name,
  disabled,
}: {
  title: string;
  onClick: (e: { value: string; isActive: boolean; name: string }) => void;
  isActive: number;
  value: string;
  name: string;
  disabled?: boolean;
}) => {
  const handleClick = () => {
    onClick({
      value,
      isActive: !isActive,
      name,
    });
  };

  return (
    <div
      className={`${styles.tableItemButtonSelect} ${
        isActive ? styles.changeButton : ""
      } ${disabled ? styles.disabled : ""}`}
      onClick={disabled ? undefined : handleClick}
      title={title || ""}>
      <div></div>
    </div>
  );
};

export default ButtonSlide;
